import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex: 1;
  height: 60vh;

  svg {
    height: 100%;
  }
`
